// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R8ScPRJFkrHUqto6ktjg div {
  display: inline-block;
}
.R8ScPRJFkrHUqto6ktjg .selectorOption {
  padding: 6px 8px;
}`, "",{"version":3,"sources":["webpack://./packages/dre-magi-translate/frontend/src/pages/admin/project/talk/item/style.module.scss"],"names":[],"mappings":"AAEI;EACE,qBAAA;AADN;AAGI;EACE,gBAAA;AADN","sourceRoot":""}]);
// Exports
export var forceInline = `R8ScPRJFkrHUqto6ktjg`;
export default ___CSS_LOADER_EXPORT___;
